import { render, staticRenderFns } from "./StatementList.vue?vue&type=template&id=751f5e1a&"
import script from "./StatementList.vue?vue&type=script&lang=js&"
export * from "./StatementList.vue?vue&type=script&lang=js&"
import style0 from "./StatementList.vue?vue&type=style&index=0&id=751f5e1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports